export enum SearchAnalysisMode {
    CaseSubmission,
    Genie,
    DetectorView
}
